<template>
  <CareerFrame
    v-if="isCareerPage"
    :job="job"
    :loading="careersLoading"
    :error="careersError"
  />
  <div v-else class="container max-w-2xl py-20 text-center">
    <h1 class="mb-8 font-semibold heading-2">
      Okay, this is weird. We can’t find that page.
    </h1>
    <img
      src="https://website-assets.atlan.com/img/404.webp"
      alt="404 image"
      class="inline-block h-auto mb-4"
    />
    <p class="mt-4 text-gray-600 mb-9">
      Maybe the link is broken or the page was moved. <br />Go back to our
      delightful home page instead?
    </p>
    <a id="404-return-button" href="/" class="px-16 btn btn-blue-500 btn-lg">Go to Home Page</a>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import CareerFrame from "src/components-vue/layout-frame/CareerFrame.vue";
import leverApi from "@utils/api/career";

const isCareerPage = ref(false);
const careersLoading = ref(false);
const careersError = ref(null);

const job = ref(null);
onMounted(async () => {
  if (document.location.pathname.includes("/careers/")) {
    const pathnameSplit = document.location.pathname.split("/");
    const jobId = pathnameSplit.at(-1) || pathnameSplit.at(-2);
    isCareerPage.value = true;

    careersLoading.value = true;
    careersError.value = null;
    await leverApi
      .fetchJobs()
      .then((res) => {
        job.value = res.find((x) => x.props.formattedJob.id === jobId);
        document.title = job.value.props.title;
      })
      .catch((e) => {
        console.error("Error: Career API", e);
        careersError.value = e;
      })
      .finally(() => {
        careersLoading.value = false;
      });
  }

  // notify GTM
  if (window.dataLayer)
    window.dataLayer.push({
      event: "page-not-found",
    });
});
</script>
